import React, { Component } from "react";
import { Link } from "react-router-dom";
import _ from "lodash";

import NumberFormat from "react-number-format";
import Table from "../../../../components/common/table/Table";
import { formatDateTimeLog } from "../../../../utils/dates";
import { Mixpanel } from "../../../../actions/mixpanel.actions";
import { INVOICE_INDEX_TABLE } from "../../../../actions/invoice.actions";

import styles from "./AdminCompanyBilling.scss";
import iconPdf from "../../../../assets/images/file-pdf.svg";
import AdminCompanyNav from "./AdminCompanyNav";

class AdminCompanyBilling extends Component {
  constructor(props) {
    super(props);
  }

  getSubmissionDate(invoice) {
    return (
      <div className={styles.rowHeaderSubtitle}>
        {formatDateTimeLog(invoice.created_at)}
      </div>
    );
  }

  getAmountDisplayText(amount) {
    return (
      <NumberFormat
        value={amount}
        displayType={"text"}
        thousandSeparator={true}
        prefix={"$"}
        decimalScale={2}
      />
    );
  }

  getStatusDisplayText(status, amount) {
    let text = status.employer;
    text = text.replace("{amount}", amount);

    return text;
  }

  getProjectDisplayText(project) {
    return (
      <div>
        <Link
          to={`/admin/project/${project.id}/detail`}
          onClick={() => Mixpanel.track("Admin - Invoices - Project Job Title")}
        >
          {project.title}
        </Link>
      </div>
    );
  }

  getMemberDisplayText(user) {
    return <div>{user.full_name}</div>;
  }

  getActions(invoice) {
    let component = invoice.file && (
      <div className={styles.actionsContainer}>
        <a
          onClick={() => this.props.downloadInvoice(invoice.id)}
          className={styles.pdfIcon}
        >
          <img src={iconPdf} alt="PDF Icon" />
        </a>
        {invoice.quickbooks_id && <div>{invoice.quickbooks_id}</div>}
      </div>
    );

    return component;
  }

  renderInvoices(mappedInvoices) {
    const tableData = {
      headers: [
        {
          displayText: "DATE",
          id: "table-employer-invoices-sort-date",
          track: "Table - Admin Invoices - Sort By Date"
        },
        {
          displayText: "PROJECT",
          id: "table-employer-invoices-sort-project",
          track: "Table - Admin Invoices - Sort By Project"
        },
        {
          displayText: "USER",
          id: "table-employer-invoices-sort-user",
          track: "Table - Admin Invoices - Sort By User"
        },
        {
          displayText: "STATUS",
          id: "table-employer-invoices-sort-status",
          track: "Table - Admin Invoices - Sort By Status"
        },
        {
          displayText: "AMOUNT",
          id: "table-employer-invoices-sort-amount",
          track: "Table - Admin Invoices - Sort By Amount"
        },
        {
          displayText: "PDF",
          align: "right",
          sortDisabled: true
        }
      ],
      rows: mappedInvoices
    };

    const defaultSort = {
      headerIndex: 0,
      order: "desc"
    };

    return (
      <div className={styles.billing}>
        <h2 className={styles.pageTitle}>Billing History</h2>

        <div className={styles.divider}>
          <div className={styles.top} />
          <div className={styles.bottom} />
        </div>

        <Table
          name={INVOICE_INDEX_TABLE}
          defaultSort={defaultSort}
          tableData={tableData}
        />
      </div>
    );
  }

  renderTable() {
    if (this.props.feed) {
      const mappedInvoices = this.props.feed.map(item => {
        const project = _.get(item, "invoice.project");
        const status = _.get(item, "status");
        const user = _.get(item, "user");

        return {
          rowKey: item.id,
          data: [
            {
              displayText: this.getSubmissionDate(item),
              orderByText: item.created_at
            },
            {
              displayText: this.getProjectDisplayText(project),
              orderByText: project.title
            },
            {
              displayText: this.getMemberDisplayText(user),
              orderByText: user.full_name
            },
            {
              displayText: this.getStatusDisplayText(status, item.amount),
              orderByText: status.id
            },
            {
              displayText: this.getAmountDisplayText(item.amount),
              orderByText: item.amount
            },
            {
              displayText: this.getActions(item.invoice)
            }
          ]
        };
      });

      return this.renderInvoices(mappedInvoices);
    }

    return null;
  }

  render() {
    const company = this.props.company;
    const projects = this.props.projects;

    return (
      <React.Fragment>
        <AdminCompanyNav
          id={company.id}
          projectsCount={projects && projects.length}
        />
        {this.renderTable()}
      </React.Fragment>
    );
  }
}

export default AdminCompanyBilling;



// WEBPACK FOOTER //
// ./src/routes/admin/company/components/AdminCompanyBilling.js